<template>
  <div class="full-height">
    <!-- <div class="tow_disti">
             <van-tabs v-model="activei" @change="switchingi" type="card" class="mag_to_bt">
                      <van-tab title="因公"></van-tab>
                      <van-tab title="因私"></van-tab>
              </van-tabs>
        </div> -->


    <div class="wid_trip" v-if="leisure">
      <div class="triptypebox">
        <trip-type slot="right"/>
      </div>
    </div>

    <div class="box">
      <!--  -->
      <div>
        <!-- <div class="text-center white box">
            <div class="font18">
              酒店住宿
            </div>
            <div class="font24">
              实惠的价格，五星的服务
            </div>
          </div> -->
  
        <tab-block
          :tab-index="model._international"
          @on-tabLeft-click="tabClick(model._international = 0)"
          @on-tabRight-click="tabClick(model._international = 1)"
        >
          <span slot="tab_left">{{ $t('A014', '国内') }}</span>
          <span
            v-if="isShowIntel"
            slot="tab_right"
          >
            海外
          </span>
  
          <div class="pd10-16-0">
            <!-- 选择出差申请单 -->
            <div
              class="Grid query-info__trip font14 font16 van-hairline--bottom"
              v-show="pageCtrl.isShowCcsqd && model._international == 0"
              @click="$refs['ccsqdlist'].toggle()"
            >
              <div
                class="Grid-cell"
                :style="{color: model._ccsqd.ccsqdNo ? 'initial' : '#999'}"
              >
                {{ model._ccsqd.ccsqdNo || $t('K108', '选择出差单') }}
              </div>
              <div
                style="margin-top: -2px;"
                v-show="model._ccsqd.ccsqdNo"
                @click.stop="showVoyage = true"
              >
                <van-tag
                  round
                  plain
                  type="warning"
                  size="large"
                  v-show="model._voyage.departCityName"
                >
                  {{
                    model._voyage.departCityName
                  }}--{{ model._voyage && model._voyage.departDate && model._voyage.departDate.substring(5) }}
                </van-tag>
                <span v-show="!model._voyage.departCityName">选择行程</span>
              </div>
            </div>
  
            <div
              class="Grid query-info__trip font14 font16"
              v-show="pageCtrl.isShowCxr"
              :class="pageCtrl.isStart && pageCtrl.showtips ? '' : 'van-hairline--bottom'"
              @click="openEmplist"
            >
              <div
                class="Grid-cell"
              >
                <span
                  class="c999"
                  v-show="!travelerList.length"
                >{{ $t('I001', '请选择出行人') }}</span>
                <span
                  v-for="(items, index) in travelerList"
                  :key="index"
                >{{ items | getName }} </span>
              </div>
            </div>
            <div
              class="Grid van-hairline--bottom"
              v-show="pageCtrl.isStart && pageCtrl.showtips && model._international == 0"
            >
              <div class="Grid-cell query-info__tips cff4f3f font10">
                {{ $t('F587', '已开启按差标等级管控出差标准，需要先选择出行人') }}
              </div>
            </div>
            <div class="Grid van-hairline--bottom query-info__loca">
              <div
                class="Grid-cell font18 font-bold"
                @click="pageCtrl.isChangeVoyage && $refs.city.toggle()"
                :class="model._city ? '' : 'c999 font-normal'"
              >
                {{ model._city || $t('H003', '入住城市') }} {{
                  model._city && model._international == 0 ? model._street : ''
                }}
              </div>
              <div
                class="Grid-cell--center"
                @click="!pageCtrl.isShowCcsqd && appGps() || pageCtrl.isShowCcsqd && pageCtrl.isChangeVoyage && appGps()"
                v-show="model._international == 0"
                style="width: 74px; display: inline-block;"
              >
                <ld-icon
                  :class="pageCtrl.isChangeVoyage ? '' : 'disabled-class'"
                  class="locationIcon main-color"
                  type="iconet-location"
                  size="18"
                />
                <span
                  :class="pageCtrl.isChangeVoyage ? '' : 'disabled-class'"
                  class="main-color"
                >我的位置</span>
              </div>
            </div>
            <div
              class="Grid Grid--1of3 van-hairline--bottom query-info__date"
              @click="showDate"
            >
              <div class="Grid-cell Grid-cell-l text-left">
                <div class="Grid-cell--autoSize font12 c999">
                  {{ $t('H006', '入住日期') }}
                </div>
                <div class="Grid-cell--autoSize query-info__date--weight font18">
                  {{ max }}&nbsp;<span class="font12 font-normal">{{ maxweek }}</span>
                </div>
  
                <!--                <div class="Grid-cell&#45;&#45;autoSize query-info__date&#45;&#45;weight font18" v-else>-->
                <!--                  {{ model._checkInDate.monDay  }}&nbsp;<span class="font12 font-normal">{{ model._checkInDate.week  }}</span>-->
                <!--                </div>-->
              </div>
              <div class="Grid-cell Grid-cell-c Grid-cell--center text-center font12">
                共<span class="query-info__tips--color">{{ model._days }}</span>晚
                <div class="arrow-line arrow-line--white" />
              </div>
              <div class="Grid-cell Grid-cell-r text-right">
                <div class="Grid-cell--autoSize font12 c999">
                  {{ $t('H007', '离店日期') }}
                </div>
                <div class="Grid-cell--autoSize query-info__date--weight font18">
                  {{ min }}&nbsp;<span class="font12 font-normal">{{ minweek }}</span>
                </div>
                <!--                <div class="Grid-cell&#45;&#45;autoSize query-info__date&#45;&#45;weight font18" >-->
                <!--                  {{ model._checkOutDate.monDay || min }}&nbsp;<span class="font12 font-normal">{{ model._checkOutDate.week }}</span>-->
                <!--                </div>-->
              </div>
            </div>
            <div
              v-show="model._international == 1"
              class="Grid Grid--1of2 van-hairline--bottom"
              style="padding: 15px 0; position: relative;"
              @click="$refs['htContactRoom'].toggle()"
            >
              <div class="Grid-cell text-left">
                <ld-icon
                  type="iconshangmenfuwu"
                  style="padding: 4px 5px 0;"
                />
                {{ model._conditions.roomCount }}{{ $t('H002', '间房') }}
              </div>
              <div class="Grid-cell text-left">
                <ld-icon
                  type="iconyonghu"
                  style="padding: 4px 5px 0;"
                />
                {{ model._conditions.adultPopulation }}
                {{ $t('C115', '成人') }}
                {{ model._conditions.childrenNumber }}
                {{ $t('C116', '儿童') }}/{{ $t('E205', '间') }}
              </div>
            </div>
            <div class="Grid Grid--full van-hairline--bottom">
              <div
                style="padding: 15px 0; position: relative;"
                class="Grid-cell query-info__searchbox font14 font16 c333"
                @click="$router.push({path: '/ht/htQuery/htSearch'})"
              >
                <div class="Grid">
                  <ld-icon
                    type="iconsousuo"
                    style="padding: 4px 5px 0;"
                  />
                  <span
                    class="Grid-cell pd0-25-0-0 line-clamp"
                    :style="{color: model._keywords ? 'initial' : '#999'}"
                  >{{ model._keywords || '关键字/位置/品牌/酒店名' }}</span>
                  <ld-icon
                    v-show="model._keywords"
                    type="iconchahao"
                    class="font18"
                    style="color: #999; position: absolute; right: 0; top: 5px; width: 44px; height: 44px; line-height: 44px; text-align: center;"
                    @click.stop="clearSearch()"
                  />
                </div>
              </div>
            </div>
  
            <div
              class="Grid Grid--full"
              v-show="model._international == 0 && pageCtrl.isStart"
            >
              <van-checkbox
                v-model="model.sfpf"
                v-show="pageCtrl.isShowPf"
                @click="$store.dispatch('ht/getTravelPolicy')"
                style="margin-top: 10px;"
              >
                是否拼房
              </van-checkbox>
              <div
                class="Grid-cell query-info__searchbox gray"
                v-if="(pageCtrl.showtips ? travelerList.length : true) && model._policy.clzcJe"
              >
                本次预订使用的差标：平均不得高于
                <span class="main-color">{{ model._policy.clzcJe }}元/间夜</span>
              </div>
            </div>
          </div>
          <div class="query">
            <ld-button
              main
              size="lg"
              @click="searchHotels"
            >
              订酒店
            </ld-button>
          </div>
        </tab-block>
      </div>
    </div>
  
    <van-tabbar
      active-color="#999"
      inactive-color="#999"
    >
      <van-tabbar-item
        v-if="!isXlminiprogram && !isKh"
        @click="$router.push('/car/carQuery')"
      >
        <span class="deep-gray">{{ $t('J051', '用车') }}</span>
        <img
          slot="icon"
          src="~Assets/images/ht/transfer.png"
        >
      </van-tabbar-item>
      <van-tabbar-item
        v-if="!isXlminiprogram && isKh"
        @click="$router.push('/home')"
      >
        <span class="deep-gray">{{ $t('A003', '首页') }}</span>
        <img
          style="transform: scale(1.25);"
          slot="icon"
          src="~Assets/images/home/1df.png"
        >
      </van-tabbar-item>
  
      <van-tabbar-item @click="toOrderList">
        <span class="deep-gray">酒店订单</span>
        <img
          slot="icon"
          src="~Assets/images/ht/myOrder.png"
        >
      </van-tabbar-item>
    </van-tabbar>
  
    <!-- 选择出行人控件 -->
    <emp-list
      ref="empList"
      cplx="10903"
      :person-list="model._ccsqd.personList"
      @selected="empCallBack"
    />
  
    <!-- 酒店选择入住/离店日期控件 -->
    <Ld-calendar
      ref="date"
      type="range"
      @selected="getDate"
    />
  
    <!-- 选择城市控件 -->
    <city
      v-if="hardReset"
      ref="city"
      @selected="arrdepChange"
      :tab-index="model._international"
      :is-hotel="true"
      :city-type="1"
      :cplx="params.cplx"
    />
  
    <!-- 出差申请单 -->
    <ld-check-list
      ref="ccsqdlist"
      type="4"
      :params="params"
      @selected="ccsqdInfo"
    />
  
    <!-- 选择行程控件 -->
    <van-popup
      v-model="showVoyage"
      position="bottom"
      :close-on-popstate="true"
      :style="{ height: '60%' }"
    >
      <div class="pd10">
        <van-tag
          round
          plain
          type="warning"
          size="large"
          v-for="(info, index) in model._ccsqd.routeBookList"
          :key="index"
          @click="changeVoyage(info)"
          style="margin-left: 10px;"
        >
          {{ info.departCityName }}-{{ info.departDate && info.departDate.substring(5) }} &nbsp;
        </van-tag>
      </div>
    </van-popup>
  
    <!-- 选择入住条件 -->
    <ht-contact-room
      ref="htContactRoom"
      :c="model._conditions"
      :search-type="model.searchType"
      @selected="getData"
    />
  </div>
</template>
  
<script>
/**
   * 业务规则
   * 1、因公出行需要显示“选择出行人”
   * 2、因公出行需要通过城市等级代码来获取当前城市的差旅标准并显示给用户
   * 3、因公出行且按公司统一标准差旅政策的可以不选择出行人，按差标等级则需要
   * 4、按差标等级需选择出行人时，选择出行人需要通过差标等级来匹配差旅标准，如果多个出行人，按差标等级最低的进行匹配
   *
   * 2021年8月19日09:37:43
   * 新增差旅标准匹配规则 - 规则都在后台匹配
   * 差旅标准根据的条件：是否拼房，城市ID，入住日期，房间集合。差标总金额，管控方式
   * 只要改变了上面的条件 都需要调接口获取一遍差旅标准
   */
import {Tabbar, TabbarItem, Popup, Tag, Checkbox,Tab, Tabs} from 'vant'
import {formatDate, getDiffDays} from 'Utils/dateUtil'
import amap from 'Utils/amap'
import {mapState, mapGetters} from 'vuex'
import {getSysType} from 'CommonUtils/plus.js'
import {gcj02tobd09} from 'Utils/convertGps.js'
import defaultMixin from '@/business/mixins/default.js'
import {isXlminp, goXlHome} from 'Utils/xltools'
  
const CPLX = $dict.PRO_TYPE.hotel
  
export default {
  name: 'HtQuery',
  mixins: [defaultMixin],
  components: {
    [Tabbar.name]: Tabbar,
    [TabbarItem.name]: TabbarItem,
    [Popup.name]: Popup,
    [Tag.name]: Tag,
    [Checkbox.name]: Checkbox,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    ldButton: () => import('Common/ldButton'),
    tripType: () => import('Common/tripType'),
    City: () => import('Common/city'),
    empList: () => import('Components/ldEmpList/index.vue'),
    LdCalendar: () => import('Common/ldCalendar'),
    HtContactRoom: () => import('Views/Ht/htQuery/htContactRoom/index.vue'),
    ldCheckList: () => import('Components/ldCheckList/index.vue'),
    tabBlock: () => import('Components/tab-block'),
  },
  props:{
    leisure:{
      type:Boolean,
      default:false
    }
  },
  data() {
    return {
      maxli: '',
      max: '',
      min: '',
      maxweek: '',
      minweek: '',
      travelPolicy: {},
      update: true,
      showVoyage: false,//是否显示出差行程列表
      voyage: {},//当前选中的行程
      params: {cplx: CPLX},
      hardReset: true,
      isShowIntel: false,
      TheSelectedTodaySdate_One: '',
      TheSelectedTodaySdate_Two: '',
      activei:''
    }
  },
  computed: {
    ...mapState({
      model: state => state.ht.htSearchInfo,
      authorizationPnosMap: state => state.app.authorizationPnosMap,
    }),
    ...mapGetters({
      // 页面差旅标准对象
      pageCtrl: 'serviceCtrl', //页面控制信息
      travelerList: 'ht/travelerList',
      userInfo: 'userInfo',
      tripType: 'tripType',
    }),
    //对康辉特殊处理
    isKh() {
      let temp = window.location.href;
      if (temp.includes("app.kh.tmc.tianxiafen.com") || temp.includes("app.tmc.cct.cn")) {
        return true;
      } else {
        return false;
      }
    },
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if (from.name === 'htOrderComplete' || from.name === 'home') {
        vm.$store.commit('ht/travelerList', [])
        vm.$forceUpdate()
        // 初始化出差申请单
        vm.model._ccsqPattern.obj = {}
        vm.model._ccsqd = {}
        vm.model._voyage = {}
        vm.getPageCtrl()
      }
      if (from.name == 'htList') {
        vm.getPageCtrl()
      }
    })
  },
  beforeRouteLeave(to, from, next) {
    if (to.name == 'home') {
      this.model._international = 0
      this.$store.commit('ht/travelerList', [])
      this.getPageCtrl()
    }
    next()
  },
  updated() {
  },
  created() {
    //初始化页面控制信息
    this.$store.commit('SET_SERVICE', {cplx: CPLX})
    this.$store.commit('ht/CLEAR_ALL')
    /**
       * 日期判断
       * 当前缓存的入住日期与当前时间日期做比较，小于当前时间日期，那么将缓存中的入住和离店日期更换成当前时间日期和当前的下一天
       */
    if (this.model._checkInDate.date < formatDate().date) {
      this.model._checkInDate = formatDate()
      this.model._checkOutDate = formatDate(new Date(), 1)
      this.model.checkInDate = formatDate().date
      this.model.checkOutDate = formatDate(new Date(), 1).date
    }
    if (this.pageCtrl.isStart) {
      this.model.sfpf = true
    }
    // 获取是否开启国际酒店模块
    this.isShowIntel = this.authorizationPnosMap.find(i => i.productNo == '10910')
    this.max = formatDate(this.model.checkInDate).monDay
    this.maxweek = formatDate(this.model.checkInDate).week
    this.min = formatDate(this.model.checkOutDate).monDay
    this.minweek = formatDate(this.model.checkOutDate).week
  
  },
  mounted() {
    // 如果没有城市缓存 不是海外酒店  不是出差申请单 自动定位
    if (!this.model.cityId && this.model._international == 0 && !this.pageCtrl.isShowCcsqd) {
      setTimeout(() => {
        this.appGps()
      }, 1000)
    }
  
    this.init()
  },
  methods: {
    init() {
      this.model._min_date = ''
      this.model._max_date = ''
      let hm_ = formatDate(new Date()).hm
      if (hm_ < '06:00') {
        this.model._min_date = formatDate(new Date(), -1).date
      } else {
        this.model._min_date = formatDate(new Date()).date
      }
      if (this.pageCtrl.isShowCcsqd) {
        let ccsqdId = this.$route.query.ccsqdId
        if (ccsqdId) {
          this.$api['common/vipCcsqdGetListForChoose']({
            ccsqdId: ccsqdId,
            proType: '10903'
          }).then(res => {
            let cache = res.data || []
            if (cache.length > 0) {
              this.ccsqdInfo(cache[0])
            } else {
              this.$toast('未查询到申请单信息')
            }
          })
        }
      }
    },
    //获取当前用户的所在位置信息
    async appGps() {
      try {
        this.model._street = ''
        this.model._city = '定位中...'
        this.model._keywords = ''
        this.model.keywords = ''
        const point = await amap.appGps()
  
        if (this.model._city === '定位中...') {
          if (point) {
            if (getSysType() == 10504 || getSysType() == 10505) {//app定位成功回调
              if (point.address) {
                this.model._province = point.address.province || '' // 省
                this.model._city = point.address.city || '' // 市
                this.model._cityName = point.address.city || ''// 市
                this.model._district = point.address.district || ''// 区
                this.model._street = point.address.poiName || ''
              }
              point.lng = point.coords.longitude
              point.lat = point.coords.latitude
            }
            this.geocoder(point)
          }
        }
      } catch (error) {
        if (typeof error === 'string') {
          this.$toast(error)
        } else {
          console.error(error)
        }
      }
    },
    openEmplist() {
      if (this.pageCtrl.isShowCcsqd && !this.model._ccsqd.ccsqdId) {
        this.$toast('请选择出差申请单')
      } else {
        this.$refs['empList'].toggle({index: 1})
      }
    },
    geocoder(point) {//根据经纬度 获取详细地址信息
      var arr = gcj02tobd09(point.lng, point.lat)//转为百度坐标
      this.model.lon = arr[0] // 纬度
      this.model.lat = arr[1] // 经度
      this.model.coordsType = 'bd09ll'
      amap.Geocoder(this.model, (res) => {//根据经纬度获取城市id
        let cache = res.data || ''
        if (cache) {
          this.model._cityId = cache.cityId
          this.model.cityId = cache.cityId
          this.model._province = cache.province || '' // 省
          this.model._city = cache.city || '' // 市
          this.model._cityName = cache.city || ''// 市
          this.model._district = cache.district || ''// 区
  
          if (cache.poiList && cache.poiList[0]) {
            this.model._street = cache.poiList[0].name
          } else {
            this.model._street = cache.sematicDescription || cache.street
          }
  
        } else {
          this.$toast('定位失败, 请手动选择城市！')
        }
        this.$store.dispatch('ht/getTravelPolicy')
      })
    },
    /**
       * zclx: 政策类型
       * cplx: 产品类型
       */
    getPageCtrl() {
      this.$store.commit('ht/pageCtrl', this.pageCtrl) // 页面控制信息
      /**
         * 赋值给预定义_ccsqPattern，酒店预订流程使用该对象进行逻辑判断
         */
      this.model._ccsqPattern.checked = this.pageCtrl.isShowCcsqd
  
      if (this.pageCtrl.isShowCcsqd && this.$route.query.ccsqdId) {
        this.$api['common/vipCcsqdGetListForChoose']({
          ccsqdId: this.$route.query.ccsqdId,
          proType: CPLX
        }).then(res => {
          var cache = res.data || []
          if (cache.length > 0) {
            this.ccsqdInfo(cache[0])
          } else {
            this.$toast('未查询到申请单信息')
          }
        })
      } else if (this.pageCtrl.isDefaultName) {//默认是否当前本人预订
        let isPush = true
        this.travelerList.forEach(element => {
          if (this.userInfo.empInfo.empId == element.empId) isPush = false
        })
        if (isPush) {
          this.userInfo.empInfo.checked = true
          this.userInfo.empInfo.clkFlag = 2
          this.travelerList.push(this.userInfo.empInfo)
        }
      }
      this.$store.dispatch('ht/getTravelPolicy')
    },
    searchHotels() {
      localStorage.setItem('home','homenew')
      if (
        this.model._international == 0 &&
          this.pageCtrl.isShowCcsqd &&
          (!this.model._ccsqd.ccsqdNo || !this.model._voyage.departCityName)
      ) {
        return this.$toast('请选择出差申请单与行程！')
      }
  
      if (!this.model.cityId) return this.$toast('请重新获取定位！')
  
      if (this.pageCtrl.showtips && !this.travelerList.length && this.model._international == 0) return this.$toast('请选择出行人')
  
      // this.$router.push('/ht/htQuery/htList')
      this.$router.push({
        path: '/ht/htQuery/htList',
        query: {
          ccsqdId: this.$route.query.ccsqdId,
          routeId: this.$route.query.routeId,
          i: this.maxli
        }
      })
  
    },
    showDate() {//选择日期
      if (this.pageCtrl.isChangeDate) {
        let maxDate = ''
        if (this.model._max_date) {
          maxDate = this.model._max_date
        } else {
          maxDate = formatDate(this.model._min_date, 90).date
        }
        this.$refs.date.toggle({
          defaultDate: [this.model._checkInDate.date, this.model._checkOutDate.date],
          minDate: this.model._min_date || null,
          maxDate: maxDate,
        })
      }
    },
    /**
       * 酒店选择入住/离店日期控件回调
       * @param {*} data
       */
    getDate(data) {
      [this.model.checkInDate, this.model.checkOutDate] = data;
      [this.model._checkInDate, this.model._checkOutDate] = [formatDate(this.max[0]), formatDate(this.min[1])]
      this.model._days = getDiffDays(this.model.checkInDate, this.model.checkOutDate)
      this.$store.dispatch('ht/getTravelPolicy')
      // 日期控件
      this.max = formatDate(data[0]).monDay
      this.min = formatDate(data[1]).monDay
      this.maxweek =  formatDate(data[0]).week
      this.minweek =  formatDate(data[1]).week
    },
    empCallBack() {
      this.$store.dispatch('ht/getTravelPolicy')
    },
    /**
       * 选择城市控件回调
       * @param {*} data
       */
    arrdepChange(data) {
      console.log(data, '000')
      this.model._international = data.international == 1 ? 0 : 1
      var cache = ''
      if (data.parentName) {
        cache = ' (' + data.parentName + ') '
      }
      if (data.areaName) {
        cache = ' (' + data.areaName + ') '
      }
  
      if (this.model._international == 0) {
        this.model._city = data.cityName + cache
        this.model.cityId = data.cityId
        this.model.district = data.areaId
        this.model.areaName = data.areaName
        this.model._cityId = data.cityId
        this.model._cityName = data.cityName
      }
      if (this.model._international == 1) {
        this.model._city = data.cityName + cache
        this.model.cityId = data.cityId
        this.model.district = data.areaId
        this.model.areaName = data.areaName
        this.model._cityIdInt = data.cityId
        this.model._cityNameInt = data.cityName
      }
      this.model.lat = ''
      this.model.lon = ''
      this.model._province = ''
      this.model._district = ''
      this.model._street = ''
      this.model.searchType = 0
      this.model.keywords = ''
      this.model._keywords = data.geoName || ''
      this.model.businessZone = ''
      this.model.businessZoneName = ''
      //this.model.district = ''
      this.model.districtName = ''
      this.$store.dispatch('ht/getTravelPolicy')
    },
    /**
       * 出差申请单控件回调
       */
    ccsqdInfo(info) {
      console.log('000', new Date(info.dateBegin) >= new Date())
      if (new Date(info.dateBegin) >= new Date() ? true : false) {
        this.maxli = 0
      } else {
        this.maxli = 1
        setTimeout(() => {
          this.max = formatDate(new Date()).monDay
          this.maxweek = formatDate(new Date()).week
          console.log(this, formatDate(new Date()))
          this.min = formatDate(new Date(), 1).monDay
          this.minweek = formatDate(new Date(), 1).week
          this.model.checkInDate = formatDate(new Date()).date
          this.model.checkOutDate = formatDate(new Date(), 1).date
          console.log('00', this.model)
          this.model._days = 1
        }, 50)
      }
      this.model._ccsqPattern.obj = info
      this.model._ccsqd = info
      this.model._voyage = {}
      if (this.model._ccsqd.routeBookList.length) {
        if (this.$route.query.routeId != null && this.$route.query.routeId != undefined) {
          let routeList = this.model._ccsqd.routeBookList || []
          if (routeList.length > 0) {
            routeList.forEach(o => {
              if (this.$route.query.routeId == o.routeId) {
                this.changeVoyage(o)
              }
            })
          }
        } else {
          this.changeVoyage(this.model._ccsqd.routeBookList[0])
        }
      } else {
        this.$toast('当前出差申请单无行程！')
      }
    },
    /**
       * 选中出差申请单行程
       */
    changeVoyage(info) {
      this.model._voyage = info
      //城市id 城市名称
      this.arrdepChange({
        cityId: info.departCity,
        cityName: info.departCityName,
        international: 1
      })
      //入住日期 离店日期
      this.getDate([info.departDate, info.arriveDate])
      //酒店名称
      this.model._keywords = info.flightNo
      this.model.keywords = info.flightNo
      //出差申请单的费用预算与房间数存储 如果房间数为0 那么房间数等于出行人集合长度 最少保留1间
      //行程中的出行人
      let arr = []
      this.model._voyage.cxrId.split(',').forEach(id => {
        this.model._ccsqd.personList.forEach(item => {
          if (id == item.contactsId || id == item.personId || id == item.empId) {
            arr.push(item)
          }
        })
      })
      this.$store.commit('ht/travelerList', arr)
      this.$store.dispatch('ht/getTravelPolicy')
      /**
         * 赋值给预定义_ccsqPattern，酒店预订流程使用该对象进行逻辑判断
         */
      this.model._ccsqPattern.fyys = info.fyys
      this.model._ccsqPattern.fjs = info.fjs || arr.length || 1
      this.showVoyage = false
      //查询出差申请单预订行程可否变更范围
      if (this.pageCtrl.isChangeDateRange > 0) {
        this.model._min_date = formatDate(this.model._voyage.departDate, -this.pageCtrl.isChangeDateRange).date
        this.model._max_date = formatDate(this.model._voyage.arriveDate, this.pageCtrl.isChangeDateRange).date
      }
    },
    clearSearch() {//清空搜索 还原默认
      this.model.searchType = 0
      this.model.keywords = ''
      this.model._keywords = ''
      this.model.businessZone = ''
      this.model.businessZoneName = ''
      this.model.district = ''
      this.model.districtName = ''
      this.model.lat = ''
      this.model.lon = ''
      this.model.brandIds = ''
    },
    changeTripType(data) {
      this.model.tripType = data
      this.$store.commit('SET_SERVICE', {zclx: 'zcJd', cplx: '10903'})
      this.getPageCtrl()
    },
    /**
       * 国际国内
       */
    tabClick() {
      this.hardReset = false
      if (this.model._international == 0) {
        if (this.model._cityId) {
          this.model._keywords = ''
          this.model.keywords = ''
          this.model.cityId = this.model._cityId
          this.model._city = this.model._cityName
        } else {
          this.appGps()
        }
      }
      /**
         * 国际酒店不需要经纬度定位当前城市
         * 默认[曼谷][13071]
         */
      if (this.model._international == 1) {
        this.clearSearch()
        this.model.cityId = this.model._cityIdInt ? this.model._cityIdInt : '13071'
        this.model._city = this.model._cityNameInt ? this.model._cityNameInt : '曼谷'
        /**
           * 移除差旅标准
           */
        this.model._policy = {
          totalClzcJe: '',
          clzcJe: '',
          gkfs: '',
          wjMonths: '',
          clzcBhFwf: '0'
        }
        this.travelPolicy = this.model._policy
      }
      this.$nextTick(() => {
        this.hardReset = true
      })
    },
    /**
       * 获取入住人条件
       */
    getData(data) {
      this.model._conditions = data
    },
    /**
       * 跳转行程页面
       */
    toOrderList() {
      this.$store.commit('SET_ORDERLISTPARAMS', {
        findType: 1,
        productType: CPLX
      })
      this.$router.push('/allorder')
    },
    back() {
      if (isXlminp()) {
        return goXlHome()
      }
      this.$router.push({path: '/home'})
    },
    switchingi(v){
      // console.log("SET_TRIPTYPE", String(v+1))
      this.$store.commit('SET_TRIPTYPE', String(v+1))
      this.$nextTick(() => this.$store.commit('RENEW_SERVICE'))
    }
  },
}
</script>
  
  <style lang="less" scoped>
  @import '~Assets/styles/currency/ht.less';
  
  .htQuery {
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
  
    .box {
      padding: 10px;
    //   height: 300px;
    }
  }
  
  .plus-card-wrap {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 60px;
  }
  
  
  .query {
    padding: 20px 24px;
  }
  
  .query-info__trip {
    padding: 12px 0;
  }
  
  .query-info__tips {
    background-color: @color-background-lightYellow;
    border-radius: 10px;
    padding: 2px 5px;
    margin: 10px 0 10px 0;
  }
  
  .query-info__loca, .query-info__date {
    padding: 12px 0;
  }
  
  .query-info__date--weight {
    font-weight: bold;
    color: #2e3033;
  }
  
  .query-info__searchbox {
    padding: 12px 0;
  }
  
  .Button__linear--current {
    width: 100%;
    border-radius: 20px;
    padding: 10px 0;
  }
  
  .locationIcon {
    float: left;
    margin-top: 1px;
  }
  
  .disabled-class {
    color: #ccc !important;
  }
  
  .pd10-16-0 {
    padding: 10px 16px 0;
  }
  
  .pd0-25-0-0 {
    padding: 0 25px 0 0;
  }
  
  .Grid--1of3 > .Grid-cell-l {
    flex: 0 0 40% !important;
  }
  
  .Grid--1of3 > .Grid-cell-r {
    flex: 0 0 40% !important;
  }
  
  .Grid--1of3 > .Grid-cell-c {
    flex: 0 0 20% !important;
  }
  .trip-type{
    background-color: #f1f4f8;
    border: 1px solid;
  }
  /deep/ .van-tabs__wrap {
  height: 35px !important;
}

/deep/ .van-tabs__nav--card {
  width: 100%;
  margin: 0 0px;
  height: 35px !important;
  border: 1px solid #eb610000;
  border-color: #ffffff00;
  background: #f1f4f8;
  display: flex;
  align-items: center;
}

/deep/ .van-tabs--card .van-tab {
  color: #000000;
}

/deep/ .van-tabs--card .van-tab.van-tab--active {
  height: 26px;
  background-color: #fff;
//   font-size: 17px;
//   font-weight: 700;
  margin: 0px 5px 0 5px;
  border-radius: 3px;
}

/deep/ .van-tabs__nav--card .van-tab {
  border-right: 1px solid #eb610000;

}
  .mag_to_bt{
    width:78%;
    // margin-bottom: 6px;
  }
  .tow_disti{
    display: flex;
    justify-content: center;
  }
   // 因公因私
   .wid_trip{
    display: flex;
    width: 100%;
    justify-content: center;

  }
  .triptypebox{
    display: flex;
    justify-content: center;
    width: 80%;
   
     /deep/ .trip-type{
        // border: 1px solid #5555 !important;
        background-color: #f1f4f8 !important;
        height:auto;
        display: flex;
        padding:3px;
     }

    /deep/ .triptype_box{
      width:100%
    }
    /deep/ .actived-left , /deep/ .actived-right{
      width:50%;
      height: 28px;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #000;
      font-size: 14px;
    }
    
  }
  </style>
    